import { Inject, Injectable } from '@angular/core';

@Injectable()
export default class MessagesActionsService {

  constructor(@Inject('Endpoint') private endpoint: any) {}

  deleteMessage(uid: string, hash?: string): void {
    const config: { [key: string]: any } = {
      uid
    };

    if (hash) {
      config.hash = hash;
    }

    this.endpoint('newCart.message', config).run();
  }
}
